import { render, staticRenderFns } from "./lab-partner-detail.vue?vue&type=template&id=23343c82"
import script from "./lab-partner-detail.vue?vue&type=script&lang=js"
export * from "./lab-partner-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports